import { FirmWithLenses, SimpleLensView } from "generated/graphql";
import { useMemo } from "react";
import { useAppSelector } from "redux/hooks";
import { selectFirmsWithLenses } from "redux/slices/client";
import { selectLenses } from "redux/slices/client";

export function useAllowedLenses(firmIds: number[]): SimpleLensView[] {
  const firmIdsSet = new Set(firmIds);
  const lenses = useAppSelector(selectLenses);
  const firms = useAppSelector(selectFirmsWithLenses);
  const filteredFirms = firms.filter((f) => firmIdsSet.has(f.id));
  const lensIdsFromFirms = useMemo(() => {
    const set = new Set();
    filteredFirms.forEach((f) => (f.lensIds || []).forEach((lensId) => set.add(lensId)));
    return set;
  }, [filteredFirms]);

  return lenses.filter((l) => lensIdsFromFirms.has(l.id));
}

export function useAllowedFirms(lensIds: number[]): FirmWithLenses[] {
  const lensIdsSet = new Set(lensIds);
  const firms = useAppSelector(selectFirmsWithLenses);

  return firms.filter((firm) => (firm.lensIds || []).find((lensId) => lensIdsSet.has(lensId)));
}

export function useFirmsByLensId(lensId: number | undefined): FirmWithLenses[] {
  const firms = useAppSelector(selectFirmsWithLenses);
  if (lensId === undefined) return [];
  return firms.filter((firm) => (firm.lensIds || []).includes(lensId));
}
